import Color from 'color';

export const setTheme = (theme: string) => {
    const ThemeMap: { [x: string]: string } = {
        LIGHT: 'light',
        DARK: 'dark',
    };

    const themeName = ThemeMap[theme] || 'custom';

    document.documentElement.setAttribute('data-theme', themeName);
};

export const getTheme = () => {
    return document.documentElement.getAttribute('data-theme');
};

export const setPrimaryColor = (primaryColor: string) => {
    const primaryColorRgb = Color(primaryColor).rgb().array().join(' ');

    document.documentElement.style.setProperty('--primary', primaryColorRgb);
};
